import React from 'react';
import {IOfficer} from "../../../api/Officer/Officer.types";
import {ArrowRightOutlined} from "@ant-design/icons";
import BrowserRouter, {BrowserRoutes} from "../../../routes/BrowserRouter";
import Button from "../../common/Button/Button";

export const OfficersTableConfig = () => {
    return [
        {
            title: 'Name', dataIndex: 'name', key: 'name',
        },
        {
            title: 'Email', dataIndex: 'email', key: 'email'
        },
        {
            title: 'Agency', dataIndex: 'agencyName', key: 'agencyName',
        },
        {
            key: 'actions', render: (officer:IOfficer) => {
                return (
                    <div className='table-row-actions'>
                        <Button icon={<ArrowRightOutlined/>} iconPosition="right" onClick={() => BrowserRouter.push(BrowserRoutes.getOfficersById(officer.id))}>
                            Details
                        </Button>
                    </div>
                )
            }
        }
    ]
}